<template>
<v-container fluid class="down-top-padding">
    <v-row>
        <v-col cols="12" sm="12">
            <BaseCard heading="Мактаблар - жадвали">
                <v-data-table :headers="headers" :items="rows" :items-per-page="5" :search="search">
                    <template v-slot:top>
                        <v-toolbar flat>
                            <v-toolbar-title>
                                <v-text-field v-model="search" append-icon="mdi-magnify" label="Қидирув" single-line hide-details></v-text-field>
                            </v-toolbar-title>
                            <v-divider class="mx-4" inset vertical></v-divider>
                            <v-spacer></v-spacer>
                            <v-dialog v-model="dialog" max-width="500px">
                                <template v-slot:activator="{ on, attrs }">
                                    <v-btn color="primary" dark class="mb-2" v-bind="attrs" v-on="on" @click="resetData">
                                        Янги мактаб
                                    </v-btn>
                                </template>
                                <v-card>
                                    <v-card-title>
                                        <span class="headline">Мактаб</span>
                                    </v-card-title>
                                    <v-divider></v-divider>
                                    <v-card-text>
                                        <v-container>
                                            <v-row>
                                                <v-col cols="12">
                                                    <v-select v-model="formData.city_id" :items="cities" item-text="name" item-value="id" filled label="Шаҳарни танланг" background-color="transparent"></v-select>
                                                </v-col>
                                                <v-col cols="12">
                                                    <v-select v-model="formData.district_id" :items="districts" item-text="name" item-value="id" filled label="Туманни танланг" background-color="transparent"></v-select>
                                                </v-col>
                                                <v-col cols="12">
                                                    <v-text-field label="Мактаб номи" required v-model="formData.name"></v-text-field>
                                                </v-col>
                                            </v-row>
                                        </v-container>
                                    </v-card-text>

                                    <v-card-actions>
                                        <v-spacer></v-spacer>
                                        <v-btn color="blue darken-1" text @click="dialog = false">
                                            Бекор қилиш
                                        </v-btn>
                                        <v-btn color="blue darken-1" text @click="submit">
                                            Сақлаш
                                        </v-btn>
                                    </v-card-actions>
                                </v-card>
                            </v-dialog>
                        </v-toolbar>
                    </template>
                    <template v-slot:[`item.actions`]="{ item }">
                        <v-icon small class="mr-2" @click="editItem(item)">
                            mdi-pencil
                        </v-icon>
                        <!--<v-icon small @click="DeleteItem(item)">
                            mdi-delete
                        </v-icon> -->
                    </template>
                </v-data-table>
            </BaseCard>
        </v-col>
    </v-row>
</v-container>
</template>

<script>
import {
    getDistrictsCity
} from '../../api/districts'

import {
    getCities
} from '../../api/cities'

import {
    getSchools,
    postSchools,
    putSchools,
    deleteSchools
} from '../../api/school'
export default {
    data() {
        return {
            dialog: false,
            edit: false,
            search: '',
            headers: [{
                    text: 'ID',
                    value: 'id'
                },
                {
                    text: 'Мактаб',
                    value: 'name'
                },
                {
                    text: 'Шаҳар',
                    value: 'City.name'
                },
                {
                    text: 'Туман',
                    value: 'District.name'
                },
                {
                    text: 'Амаллар',
                    value: 'actions',
                    sortable: false
                }
            ],
            rows: [],
            cities: [],
            districts: [],
            formData: {
                name: null,
                district_id: null,
                city_id: null
            }
        }
    },
    watch: {
        'formData.city_id': function (val) {
            if (val) this.fetchDataDistrict(val)
        }
    },
    mounted() {
        this.fetchData()
        this.fetchDataCity()
    },
    methods: {
        fetchData() {
            getSchools({
                limit: 8000,
                offset: 0
            }).then(res => {
                this.rows = res.data
                getSchools({
                    limit: 8000,
                    offset: 8000
                }).then(res1 => {
                    this.rows = this.rows.concat(res1.data)
                    console.log(res1.data)
                }).catch(error => {
                    console.log(error)
                })
            }).catch(error => {
                console.log(error)
            })
        },
        fetchDataDistrict(id) {
            getDistrictsCity(id).then(res => {
                this.districts = res.data
            }).catch(error => {
                console.log(error)
            })
        },
        fetchDataCity() {
            getCities().then(res => {
                this.cities = res.data
            }).catch(error => {
                console.log(error)
            })
        },
        submit() {
            if (!this.edit) {
                postSchools(this.formData).then(() => {
                    this.dialog = false
                    this.fetchData()
                    this.resetData()
                }).catch(error => {
                    console.log(error)
                })
            } else {
                putSchools(this.formData, this.formData.id).then(() => {
                    this.dialog = false
                    this.fetchData()
                    this.resetData()
                }).catch(error => {
                    console.log(error)
                })
            }
        },
        editItem(item) {
            this.dialog = true
            this.formData = item
            this.edit = true
        },
        DeleteItem(item) {
            deleteSchools(item.id).then(() => {
                this.fetchData()
            })
        },
        resetData() {
            this.formData = {
                name: null,
                district_id: null,
                city_id: null
            }
            this.edit = false
        }
    }
}
</script>
